export default __webpack_public_path__ + "static/media/categories_rtb.34ee6bcf.svg";